import { Widget } from '@ecocart/entities';

export const getInitialValues = (): Widget => {
  const widget = new Widget();
  widget.name = 'Eco Incentive Widget';
  widget.template = 'eco_incentives';
  return widget;
};
